import { createRoot } from 'react-dom/client'

import App from 'App'
import './i18n'

if (process.env.REACT_APP_MOCK === 'TRUE' && process.env.NODE_ENV === 'development') {
  void (async () => {
    const { worker } = await import('./mocks/browser')

    await worker.start()

    const container = document.getElementById('root')
    const root = createRoot(container)
    root.render(<App />)

    worker.printHandlers()
  })()
} else {
  const container = document.getElementById('root')
  const root = createRoot(container)

  root.render(<App />)
}
